import { useCallback } from 'react';
import { cn } from '@/util/cn';
import { useUnitContext } from '@/components/UnitSwitch/context';
import { DistanceType, TempType } from '@/i18n/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

export const UnitToggle = () => {
  const { t } = useOTSTranslation('common');
  const { distance, setTemperatureType, setDistanceType } = useUnitContext();
  const isMetric = distance === DistanceType.METRIC;

  const setMetric = useCallback(() => {
    if (setTemperatureType) {
      setTemperatureType(TempType.CELSIUS);
    }
    if (setDistanceType) {
      setDistanceType(DistanceType.METRIC);
    }
  }, []);

  const setImperial = useCallback(() => {
    if (setTemperatureType) {
      setTemperatureType(TempType.FAHRENHEIT);
    }
    if (setDistanceType) {
      setDistanceType(DistanceType.IMPERIAL);
    }
  }, []);

  return (
    <div className="inline-flex justify-center max-lg:w-full">
      <div className="inline-block pr-1.5">
        {t('common.units')}
        :
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions */}
      <a
        onClick={setMetric}
        className={cn(
          'cursor-pointer px-0.5 opacity-50 hover:opacity-100',
          isMetric && 'text-white opacity-100',
        )}
      >
        {t('common.unitsMetric')}
      </a>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions */}
      <a
        onClick={setImperial}
        className={cn(
          'cursor-pointer px-0.5 opacity-50 hover:opacity-100',
          !isMetric && 'text-white opacity-100',
        )}
      >
        {t('common.unitsImperial')}
      </a>
      <span className="px-2">/</span>
    </div>
  );
};
